module.exports = __webpack_public_path__ + "static/media/image11.ef117c07.png";